<template lang='pug'>
    div
        PDaccessoriesSelectorLinks
        div.fullwidth(v-if="$route.params.lang == 'en'")

            section.title-container
                h1.product-title Sensor Case
                h2.product-subtitle Robust carrying case for UHF drain valve sensors

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/SensorCase.webp')
                            img( src='@/assets/photos/for_product_overview/SensorCase.png', width="70%", alt='Sensor Case for UHF Sensors', title='Sensor Case for UHF Sensors')
                        
                    .column.factsandbluebox
                        .factbox
                            span.headline Key Features:
                            ul
                                li Durable case construction ensures safe transport and storage of UHF sensors
                                li Waterproof, dustproof and impact-resistant design for reliable protection
                                li IP protection class IP67
                                li Accommodates up to two UHF drain valve sensors (UHF-DVS-50 or UHF-DVS-25) in a secure layout
                            
                        .bluebox
                            Maillink(to='support@bss-hs.de', sub='Sensor Case', text='Contact Us', size=30, strokeWidth=2)
                            Sitelink(to="/en/products/uhfsensors/overview", text='UHF Sensors')
            
            section.margin-bottom
                p The robust carrying case offers reliable protection for UHF drain valve sensors during transport and storage. Based on a Peli™ Air case with a precision-cut foam insert, it securely holds up to two UHF drain valve sensors of the types UHF-DVS-50 or UHF-DVS-25. The waterproof, dustproof, and impact-resistant design with IP67 protection ensures maximum safety for sensitive measurement equipment, even in harsh environmental conditions. Available upon request.

        div.fullwidth(v-if="$route.params.lang == 'de'")

            section.title-container
                h1.product-title Sensorkoffer
                h2.product-subtitle Robuster Tragekoffer für UHF-Schiebesensoren

            section.margin-bottom
                .column-container
                    .column.center-content
                        picture.main-product-picture
                            source(type='image/webp', srcset='@/assets/photos/for_product_overview/SensorCase.webp')
                            img( src='@/assets/photos/for_product_overview/SensorCase.png', width="70%", alt='Sensorkoffer für UHF-Sensoren', title='Sensorkoffer für UHF-Sensoren')
                    .column.factsandbluebox
                        .factbox
                            span.headline Highlights:
                            ul
                                li Robuste Gehäusekonstruktion für sicheren Transport und Lagerung von UHF-Sensoren
                                li Wasser-, staub- und stoßfestes Design für zuverlässigen Schutz
                                li IP-Schutzklasse IP67
                                li Bietet Platz für bis zu zwei UHF-Schiebesensoren (UHF-DVS-50 oder UHF-DVS-25) in sicherer Anordnung
                            
                        .bluebox
                            Maillink(to='support@bss-hs.de', sub='Sensor Case', text='Kontakt', size=30, strokeWidth=2)
                            Sitelink(to="/de/products/uhfsensors/overview", text='UHF-Sensoren')
            
            section.margin-bottom
                p Der robuste Transportkoffer bietet zuverlässigen Schutz für UHF-Schiebesensoren während Transport und Lagerung. Er basiert auf einem Peli™-Air-Koffer mit präzise zugeschnittenem Schaumstoffeinsatz und ermöglicht die sichere Aufnahme von bis zu zwei UHF-Schiebesensoren der Typen UHF-DVS-50 oder UHF-DVS-25. Das wasser-, staub- und stoßfeste Design mit IP67 Schutzklasse gewährleistet maximale Sicherheit für empfindliche Messequipment – selbst unter rauen Umgebungsbedingungen. Auf Anfrage erhältlich.
                        
</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | Sensorkoffer",
            description: "Tragekoffer für UHF-Schiebesensoren",
        },
        en: {
            title: "BSS | UHF Sensor Case",
            description: "Hard-carry-case for Drain Valve UHF Sensors",
        },
    },
};
</script>

<style scoped lang='sass'>
</style>